import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function Show(props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 24 24">
      <path d="M3.38683 18.4539L11.1828 22.872C11.7375 23.189 12.2625 23.189 12.8271 22.872L20.6132 18.4539C21.5245 17.9388 22 17.4138 22 15.9973V8.15181C22 7.1216 21.6236 6.47771 20.7915 6.00223L13.7781 2.02006C12.5795 1.32665 11.4205 1.32665 10.2219 2.02006L3.21842 6.00223C2.37642 6.47771 2 7.1216 2 8.15181V15.9973C2 17.4138 2.48539 17.9388 3.38683 18.4539ZM12.005 11.4901L4.3576 7.16122L10.8856 3.4366C11.6483 3.00074 12.3517 2.99084 13.1243 3.4366L19.6523 7.16122L12.005 11.4901ZM4.27836 17.1464C3.70381 16.8294 3.5057 16.4926 3.5057 15.9477V8.4688L11.2224 12.8769V21.0988L4.27836 17.1464ZM19.7316 17.1464L12.7776 21.0988V12.8769L20.4943 8.4688V15.9477C20.4943 16.4926 20.2962 16.8294 19.7316 17.1464Z"/>
    </CommonSVGIcon>
  );
}
